var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"box",attrs:{"value":_vm.value},on:{"dragenter":_vm.ondrag,"dragleave":_vm.ondrag,"dragover":_vm.ondragover,"drop":_vm.ondrop}},[_vm._v(" 点击上传或将文件拖拽至此处 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }